import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './vm-video-comments-list-item';
import type { CommentData } from 'Api/comments';
import Styles from './vm-video-comments-list.scss';

/**
 * Renders an unordered list of `<vm-video-comments-list-item>` elements
 * from the supplied `commentsData` array, forwarding permission flags
 * and `videoSlug` down to each item. Items render their own nested
 * replies (and set `isReply` on them internally); this list only walks
 * the root level.
 *
 * Renders nothing when `commentsData` is empty.
 */
@customElement('vm-video-comments-list')
export class VmVideoCommentsList extends LitElement {
    static override styles = Styles;

    @property({ type: Array }) commentsData: CommentData[] = [];
    @property({ type: Boolean }) dataAddCommentsPerm = false;
    @property({ type: String }) videoSlug = '';
    /** Session user info; forwarded to each item so inline reply composers show the right avatar. */
    @property({ type: String }) userAvatarSrc = '';
    @property({ type: String }) userAvatarName = '';
    @property({ type: String }) userProfileUrl = '';

    private get _hasComments(): boolean {
        return (this.commentsData?.length ?? 0) > 0;
    }

    override render() {
        if (!this._hasComments) return nothing;

        return html`
            <ul class="comments__list">
                ${this.commentsData.map(
                    (c) => html`
                        <vm-video-comments-list-item
                            .comment=${c}
                            .dataAddCommentsPerm=${this.dataAddCommentsPerm}
                            .videoSlug=${this.videoSlug}
                            .userAvatarSrc=${this.userAvatarSrc}
                            .userAvatarName=${this.userAvatarName}
                            .userProfileUrl=${this.userProfileUrl}
                        ></vm-video-comments-list-item>
                    `,
                )}
            </ul>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-video-comments-list': VmVideoCommentsList;
    }
}
